import {
  DashboardActions,
  InternalDashboardActions,
} from '@store/reducers/dashboard/actions'
import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { removeAvatar } from './removeAvatar'
import { rename } from './rename'
import { renameRequest } from './renameRequest'
import { updateAvatar } from './updateAvatar'

export function* teamsSaga() {
  yield all([
    takeEvery(DashboardActions.teams.rename, rename),
    takeEvery(DashboardActions.teams.updateAvatar, updateAvatar),
    takeEvery(DashboardActions.teams.removeAvatar, removeAvatar),
    takeLatest(InternalDashboardActions.renameRequest, renameRequest),
  ])
}
